import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppLoadService, AuthInterceptor, CustomSerializer, OpmCoreModule, OpmSharedModule, ShellEffects } from '@opm/ng-core';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { reducerToken, metaReducers, reducerProvider } from './core/state';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NavigationActionTiming, RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { environment } from 'src/environments/environment';
import { Lookups } from 'core/state/lookup-state';
import { LookupEffects } from 'core/state/effects';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    OpmSharedModule,
    OpmCoreModule,
    CoreModule,
    SharedModule,
    StoreModule.forRoot(reducerToken, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    }),
    EffectsModule.forRoot([ShellEffects, LookupEffects]),
    StoreDevtoolsModule.instrument({
      name: 'FLIS Dev Tools',
      maxAge: 50,
      logOnly: environment.production
    }),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'routes',
      navigationActionTiming: NavigationActionTiming.PostActivation
    })
  ],
  providers: [
    AppLoadService,
    {
      provide: RouterStateSerializer,
      useClass: CustomSerializer
    },
     //{
     //  provide: APP_INITIALIZER,
     //  useFactory: getUserToken,
     //  deps: [AppLoadService],
     //  multi: true
     //},
    reducerProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function getUserToken(appLoadService: AppLoadService) {
  return () => appLoadService.getUserToken();
}
